module.exports = __webpack_public_path__ + "static/media/r_dot_16.70fd13e1.png";